export const ClearIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <mask
        id="mask0_460_17182"
        width="16"
        height="16"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#D9D9D9" d="M0 0h16v16H0z" />
      </mask>
      <g mask="url(#mask0_460_17182)">
        <path
          fill="#525252"
          d="m4.267 12.667-.934-.934L7.067 8 3.333 4.267l.934-.934L8 7.067l3.733-3.734.934.934L8.933 8l3.734 3.733-.934.934L8 8.933l-3.733 3.734Z"
        />
      </g>
    </svg>
  );
};
